import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useAntdMessage } from "hooks/useAntdMessage";
import { useDownloadMessageMedia } from "queries/conversation";

const DownloadVideoBtn = ({ messageId, fileName }) => {
  const { message } = useAntdMessage();
  const { mutate: downloadVideo, isPending } = useDownloadMessageMedia();
  const handleDownload = () => {
    downloadVideo(
      { messageId, fileName },
      {
        onError: (error) => {
          message.error("Gagal mengunduh video");
          console.error(error);
        },
        onSuccess: () => {
          message.success("Video berhasil diunduh");
        },
      }
    );
  };
  return (
    <Button
      size="small"
      type="default"
      icon={<DownloadOutlined />}
      onClick={handleDownload}
      loading={isPending}
      className="bg-blue-500 text-white border-blue-500 hover:bg-blue-600 hover:border-blue-600 hover:text-white"
    >
      Download Video
    </Button>
  );
};

export default DownloadVideoBtn;
